import React from 'react';
import styled from '@emotion/styled';
import { H3 } from '../../../../ui';
import Responsive from '../../../../ui/utils/Responsive';

interface ICurrentTierPointsTitleProps {
	title: string;
}
export const CurrentTierPointsTitle = ({
	title,
}: ICurrentTierPointsTitleProps) => (
	<StyledCurrentPoints>{title}</StyledCurrentPoints>
);
const StyledCurrentPoints = styled(H3)`
	margin: 0;
	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		font-size: 24px;
	}
`;
